import { createPatch } from 'rfc6902';
import { uuidv7 } from 'uuidv7';
import { EventLogs } from '../../utils.js';
import { addEventLog, EventLogResources } from '../util.js';
import { zql } from '../../schema.js';
import { isSequenceBeforeProduction } from '../../util/patients-therapies.js';
import { buildCancelSequenceOps } from './cancel-protocol-sequences.js';
export async function stopPatientProtocol(tx, input, userId) {
    const now = Date.now();
    const patientProtocol = await tx.run(zql.patientProtocols
        .related('protocol')
        .where('id', '=', input.patientProtocolId)
        .where('deletedAt', 'IS', null)
        .one());
    if (!patientProtocol)
        throw new Error('Not Found');
    const characteristics = await tx.run(zql.patientCharacteristics
        .related('patient')
        .where('patientId', '=', patientProtocol.patientId)
        .orderBy('createdAt', 'desc')
        .limit(1)
        .one());
    const sequences = await tx.run(zql.patientTherapySequence
        .where('patientProtocolId', '=', input.patientProtocolId)
        .where('deletedAt', 'IS', null));
    const sequenceOps = [];
    const logSequenceOps = [];
    const sequencesToCancel = sequences.filter(isSequenceBeforeProduction);
    for (const seq of sequencesToCancel) {
        const { sequenceOps: cancelOps, logOps } = buildCancelSequenceOps(tx, seq, {
            now,
            userId,
            patientId: patientProtocol.patientId,
            patientName: characteristics?.patient?.fullName ?? '',
            reason: input.reason,
        });
        sequenceOps.push(...cancelOps);
        logSequenceOps.push(...logOps);
    }
    sequenceOps.push(() => tx.mutate.patientProtocols.update({
        id: input.patientProtocolId,
        endDate: now,
        updatedAt: now,
        updatedBy: userId,
    }));
    await Promise.all(sequenceOps.map(op => op()));
    await Promise.all(logSequenceOps.map(op => op()));
    if (tx.location === 'server') {
        await addEventLog(tx, {
            id: uuidv7(),
            resource: EventLogResources.patientProtocol,
            resourceId: input.patientProtocolId,
            action: 'update',
            domain: 'patient',
            event: EventLogs.PATIENT_PROTOCOL_STOPPED,
            patches: createPatch({ endDate: patientProtocol.endDate }, { endDate: now }),
            status: 'OK',
            performedBy: userId,
            performedAt: now,
            details: {
                patientId: patientProtocol.patientId,
                patientName: characteristics?.patient?.fullName ?? '',
                protocolName: patientProtocol.protocol?.name,
                cancelledPrescriptions: String(sequencesToCancel.filter(seq => !seq.isNote).length),
                reason: input.reason,
            },
        });
    }
}
//# sourceMappingURL=stop-patient-protocol.js.map